<template>
    <div id="go_ContactInfo">
        <v-container class="pt-0">
            <v-card>
                <v-card-title primary-title><h2 :style="'color:' + theme.primary.base">Contact Information</h2></v-card-title>
                <v-form class="pl-4 pr-4">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <input type="hidden" :value="validationWatcher"/>
                            <v-alert
                                v-model="validation.showAlert"
                                type="error"
                            >
                            {{validation.message}}
                            </v-alert>       
                        </v-flex>            
                    </v-layout>                    
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-text-field
                                label="* Phone number"
                                outline
                                maxlength="20"
                                :rules="[rules.required,rules.azAZNumSpace]"
                                v-model="contactPerson.phoneNo"
                                :background-color="helper.colors.required"
                            ></v-text-field>                          
                        </v-flex>                    
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md6>
                            <div id="divTxtFld_Name">
                                <v-text-field
                                    label="* Name"
                                    :rules="[rules.required,rules.azAZSpace]"
                                    maxlength="100"
                                    outline
                                    v-model="name"
                                    :background-color="helper.colors.required"
                                ></v-text-field> 
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <div id="divTxtFld_Email">
                                <v-text-field
                                    label="* Email address"
                                    :rules="[rules.required, rules.email]"
                                    maxlength="50"
                                    outline
                                    v-model="contactPerson.email"
                                    :background-color="helper.colors.required"
                                ></v-text-field>         
                            </div>                 
                        </v-flex>                    
                    </v-layout>                   
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-textarea
                            outline
                            name="input-7-4"
                            label="Address"
                            maxlength="250"
                            value=""
                            v-model="contactPerson.address"
                            ></v-textarea>
                        </v-flex>                  
                    </v-layout>              
                </v-form>
            </v-card>
        </v-container>  
    </div>

</template>

<script>
import Validation from './Passenger.Validation';
import Helper from '../helper';
import Theme from '../../theme';

export default {
    props:["validationWatcher"],
    data(){
        return {
            passengerReferences:["Specify","Adult 1","Adult 2"],
            contactPerson:{},    
            name:"",  
            emitters:{
                emContactInfo:"emContactInfo",
                emValidationPassed:"emValidationPassed",
            }, 
            phoneNo:""  ,
            email:"",  
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
                azAZSpace: value => {return Helper.keypressFiltering.azAZSpace(value) ||'Invalid input'},
                azAZNumSpace: value => {return Helper.keypressFiltering.azAZNumSpace(value) ||'Invalid input'},                
            },
            allowNextValidation:true,
            validation:{
                showAlert:false,
                message:"",
            },  
            helper:Helper,       
            theme:Theme,         
        }
    },
    created(){
        this.initializeViewModelData();        
    },
    updated(){
        if (this.validationWatcher == true && this.allowNextValidation==true){
            this.allowNextValidation = false;
            //this.validation = Validation.validateContactInfoBoxValue(this.contactPerson);
            Validation.validateContactInfoBoxValue(this.contactPerson).then(rslt=>{
                this.validation = rslt;
                this.emitValidationResult(rslt.showAlert==false);
            });
            
        }else if (this.validationWatcher == false){
            this.allowNextValidation = true;
        }        
        this.emitContactInfo();
    },
    methods:{
        emitValidationResult(result){
            this.$emit(this.emitters.emValidationPassed,result);
        },
        initializeViewModelData(){
            this.contactPerson = {
                phoneNo:"",
                title:"-",
                firstName:"",
                middleName: "",
                lastName:"",
                address:"",
                country:"",
                email:"",
            }
        },
        getNames(){

            ("getNames **");
            let names = this.name.split(' ');
            
                this.contactPerson.firstName = "";
                this.contactPerson.middleName = "";
                this.contactPerson.lastName = "";

            if (names.length==2){
                if (names[0]!=null) this.contactPerson.firstName = names [0];
                this.contactPerson.middle = "";
                if (names[1]!=null) this.contactPerson.lastName = names [1];
            }else if (names.length==1){
                if (names[0]!=null) this.contactPerson.firstName = names [0];
                this.contactPerson.middleName = "";
                this.contactPerson.lastName = "-";
            }else if (names.length==3){
                if (names[0]!=null) this.contactPerson.firstName = names [0];
                if (names[1]!=null) this.contactPerson.middle = names [1];
                if (names[2]!=null) this.contactPerson.lastName = names [2];
            }

            if (this.contactPerson.firstName=="" || this.contactPerson.firstName==null){
                this.contactPerson.firstName = "";
                this.contactPerson.middleName = "";
                this.contactPerson.lastName = "";
            }
        },
        emitContactInfo(){
            this.getNames();
            this.$emit(this.emitters.emContactInfo,this.contactPerson);
        }
    },
}
</script>

<style>
#divTxtFld_Email > div > div > div.v-input__slot > div > input[type=text],
#divTxtFld_Name > div > div > div.v-input__slot > div > input[type=text]{
    text-transform: uppercase;
}
</style>